import type {ReactElement} from 'react';
import React from 'react';
import {DesignSeekItemBackgroundContainer} from '@Components/poster-editor/components/poster-editor-web-bottom-bar/components/design-seek-item-background-container/design-seek-item-background-container';
import styles from './page-thumbnail.module.scss';

interface PageThumbnailProps {
  pageId: string;
  isSelected?: boolean;
}

export function PageThumbnail({pageId, isSelected = false}: PageThumbnailProps): ReactElement {
  return (
    <div className={`${styles.thumbnail} ${isSelected ? styles.selected : ''}`}>
      <DesignSeekItemBackgroundContainer pageId={pageId} />
    </div>
  );
}
